module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-leave-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [(_vm.isEditMode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title_edit')))]) : _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title_add')))])]), _vm._v(" "), (_vm.preLoaded) ? _c('div', {
    staticClass: "leave-form"
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('message.leave.doctor')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "doctor",
      "placeholder": _vm.$t('message.leave.doctor_placeholder'),
      "options": _vm.doctor_options,
      "allow-empty": true,
      "disabled": _vm.isEditMode,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.leave.doctor),
      callback: function($$v) {
        _vm.leave.doctor = $$v
      },
      expression: "leave.doctor"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.doctor_id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-padding-bottom"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('div', {
    staticClass: "form-divider"
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "allDayCheckBox"
  }, [_c('div', {
    staticClass: "squaredThree"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leave.all_day),
      expression: "leave.all_day"
    }],
    attrs: {
      "type": "checkbox",
      "value": "None",
      "id": "allday"
    },
    domProps: {
      "checked": Array.isArray(_vm.leave.all_day) ? _vm._i(_vm.leave.all_day, "None") > -1 : (_vm.leave.all_day)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.leave.all_day,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "None",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.leave.all_day = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.leave.all_day = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.leave.all_day = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "allday"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "allDayLabel"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.all_time')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.leave.leave_date')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_date_placeholder'),
      "config": _vm.fpConfig
    },
    model: {
      value: (_vm.selectedDateTime.start_date),
      callback: function($$v) {
        _vm.selectedDateTime.start_date = $$v
      },
      expression: "selectedDateTime.start_date"
    }
  })], 1), _vm._v(" "), (!_vm.leave.all_day) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_time_placeholder'),
      "config": _vm.fpTimeConfig
    },
    model: {
      value: (_vm.selectedDateTime.start_time),
      callback: function($$v) {
        _vm.selectedDateTime.start_time = $$v
      },
      expression: "selectedDateTime.start_time"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.start_time
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('message.leave.to')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_date_placeholder'),
      "config": _vm.fpConfig
    },
    model: {
      value: (_vm.selectedDateTime.end_date),
      callback: function($$v) {
        _vm.selectedDateTime.end_date = $$v
      },
      expression: "selectedDateTime.end_date"
    }
  })], 1), _vm._v(" "), (!_vm.leave.all_day) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('flat-pickr', {
    staticClass: "flatpickr-input",
    attrs: {
      "placeholder": _vm.$t('message.leave.leave_time_placeholder'),
      "config": _vm.fpTimeConfig
    },
    model: {
      value: (_vm.selectedDateTime.end_time),
      callback: function($$v) {
        _vm.selectedDateTime.end_time = $$v
      },
      expression: "selectedDateTime.end_time"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.end_time
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "type": "textarea",
      "label": _vm.$t('message.leave.remark'),
      "placeholder": _vm.$t('message.leave.remark')
    },
    model: {
      value: (_vm.leave.description),
      callback: function($$v) {
        _vm.leave.description = $$v
      },
      expression: "leave.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelLeave
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addLeave
    }
  }, [_vm._v(_vm._s(_vm.isEditMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1), _vm._v(" "), (_vm.isEditMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-leave-action",
    on: {
      "click": _vm.removeLeave
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _c('div', {
    staticClass: "btn btn-sm text-center detail-loader"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec08fec6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/leave/LeaveDetail.vue
// module id = 1055
// module chunks = 1